export const controlPanelEn = {
  pageTitle: "Control Panel",
  pageSubtitle: "AI-powered category management system to optimize assortments and planograms",

  workflow: {
    title: "Workflow Process",
    subtitle: "Your step-by-step category management flow",
    step: "STEP {{number}}",
    majorReview: "MAJOR REVIEW",
    majorReviewDesc: "Complete assortment optimization",
    minorReview: "MINOR REVIEW",
    minorReviewDesc: "Quick planogram validation",
  },

  steps: {
    performanceAnalysis: "Performance Analysis",
    performanceAnalysisDesc:
      "Analyze category performance, identify actions, and generate simulations",
    assortmentSimulation: "Assortment Simulation",
    assortmentSimulationDesc:
      "Edit and optimize simulations for major and minor review, and generate planograms",
    spacePlanning: "Space Planning",
    spacePlanningDesc: "Validate planogram arrangements and edit layouts as needed",
    minorReviewTitle: "Minor Review",
    minorReviewDesc: "Review planogram alerts and validate assortment compliance (Minor Review)",
  },

  objects: {
    title: "Objects Summary",
    subtitle: "Current inventory of your system objects",
    stores: "Stores",
    storesDesc: "Store locations and cluster groupings",
    clusters: "Clusters",
    planograms: "Planograms",
    planogramsDesc: "Planograms and assortment definitions",
    assortments: "Assortments",
    categories: "Categories",
    categoriesDesc: "Product catalog and category hierarchies",
    products: "Products",
    productsDesc: "Product catalog and SKU management",
    fixtures: "Fixtures",
    fixturesDesc: "Store fixture definitions and configurations",
    decisionTrees: "Merchflows",
    decisionTreesDesc: "Category decision trees for planogram distribution",
    trees: "Trees",
    active: "Active",
  },

  alerts: {
    title: "Planogram Alerts",
    subtitle: "Warnings in active planograms requiring attention",
    critical: "Critical",
    medium: "Medium",
    low: "Low",
    category: "Category: {{category}}",
    outOfStockTitle: "Out of stock products in planograms",
    outOfStockDesc:
      "15 Salsas planograms have SKUs with no inventory (VALENTINA Picante, BÚFALO Chipotle, CHOLULA Original)",
    underperformingTitle: "Underperforming planograms",
    underperformingDesc:
      "8 Salsas planograms have sales -18% below cluster average in last 4 weeks",
    underutilizedTitle: "Underutilized shelf space",
    underutilizedDesc: "12 Salsas planograms have 22% empty space - opportunity to expand top SKUs",
    complianceTitle: "Assortment compliance failure",
    complianceDesc:
      "6 planograms missing HERDEZ Tradicional and TABASCO Original per mandatory assortment",
    atRiskTitle: "Category at risk",
    atRiskDesc: "This category has a low health score and requires immediate attention",
    watchTitle: "Category under watch",
    watchDesc: "This category shows declining performance and should be monitored",
    storeContext: "{{storeCount}} stores affected ({{stores}})",
    storeContextAll: "{{storeCount}} stores affected",
    deadStockTitle: "Dead stock detected",
    missingTopProductsTitle: "Top products missing from stores",
    lowPerformanceTitle: "Stores underperforming in category",
    affectedStoresHeading: "Affected stores ({{count}})",
    missingProductsHeading: "Missing products ({{count}})",
    noData: "No alerts available",
    loadErrorTitle: "Alert load failed",
    loadError: "Could not load alerts from the API",
  },
} as const;

export type ControlPanelTranslations = typeof controlPanelEn;
